import React, { useState, useEffect } from "react";
import "./App.css";
import PlayerComparisonPage from "./pages/PlayerComparisonPage/PlayerComparisonPage";
import FixtureCalendarPage from "./pages/FixtureCalendarPage/FixtureCalendarPage";
import HomePage from "./pages/HomePage/HomePage";
import Top10Page from "./pages/Top10Page/Top10Page";
import TeamsPage from "./pages/TeamsPage/TeamsPage";
import FAQPage from "./pages/FAQPage/FAQPage";
import FDRComparisonPage from "./pages/FDRComparisonPage/FDRComparisonPage";
import DraftPage from "./pages/DraftPage/DraftPage";
import { teams, fdrReady } from "./components/dummyArrays/dummy";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import Navbar from "./components/navbar/navbar";

export default function App() {
  const [mainData, setMainData] = useState(null);
  const [fixturesData, setFixturesData] = useState(null);
  const [activeGameweek, setActiveGameweek] = useState(null);
  const [teamsData, setTeamsData] = useState(teams);

  // Once the async FDR fetch in dummy.js completes, spread the array to give
  // React a new reference so components re-render with the Supabase values
  useEffect(() => {
    fdrReady.then(() => setTeamsData([...teams]));
  }, []);

  // Fetch the FPL API data from new server
  useEffect(() => {
    async function fetchFPL() {
      try {
        const bootstrapResponse = await fetch(
          "https://fpl-server-nine.vercel.app/api?endpoint=bootstrap-static"
        );
        if (!bootstrapResponse.ok) {
          throw new Error(`HTTP error! Status: ${bootstrapResponse.status}`);
        }
        const fetchedData = await bootstrapResponse.json();
        setMainData(fetchedData); // Set the fetched data to mainData

        // Fetch fixtures data
        const fixturesResponse = await fetch(
          "https://fpl-server-nine.vercel.app/api?endpoint=fixtures"
        );
        if (!fixturesResponse.ok) {
          throw new Error(`HTTP error! Status: ${fixturesResponse.status}`);
        }
        const fixturesData = await fixturesResponse.json();
        setFixturesData(fixturesData);

        // Find the active gameweek: the first one not yet fully played, judged
        // by each fixture's finished_provisional flag (flips true right after
        // the final whistle) rather than the event's own `finished` flag,
        // which lags by hours while FPL confirms bonus points.
        const sortedEvents = [...fetchedData.events].sort((a, b) => a.id - b.id);
        const activeEvent = sortedEvents.find((event) => {
          const eventFixtures = fixturesData.filter((f) => f.event === event.id);
          return eventFixtures.length === 0 || eventFixtures.some((f) => !f.finished_provisional);
        });
        if (activeEvent) {
          setActiveGameweek(activeEvent.id);
        } else {
          // Default to gameweek 1 if no active gameweek found
          setActiveGameweek(1);
        }
      } catch (error) {
        console.error("Failed to fetch data:", error);
      }
    }

    fetchFPL();
  }, []);

  return (
    <div className="app">
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage fixturesData={fixturesData} />} />
          <Route path="/home" element={<Navigate to="/" />} />
          <Route
            path="/calendar"
            element={
              <FixtureCalendarPage
                teams={teamsData}
                fixturesData={fixturesData}
                activeGameweek={activeGameweek}
              />
            }
          />
          <Route
            path="/comparison"
            element={
              <PlayerComparisonPage
                mainData={mainData}
              />
            }
          />
          <Route
            path="/players"
            element={
              <Top10Page
                mainData={mainData}
                teams={teamsData}
              />
            }
          />
          <Route 
            path="/teams" 
            element={
              <TeamsPage
                teams={teamsData}
              />
            }      
          />
          <Route
            path="/faq"
            element={
              <FAQPage
              />
            }
          />
          <Route
            path="/fdr-comparison"
            element={
              <FDRComparisonPage />
            }
          />
          <Route
            path="/draft"
            element={
              <DraftPage mainData={mainData} teams={teamsData} fixturesData={fixturesData} />
            }
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}
